var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('main',[_c('LoginTable',{attrs:{"mainStyle":"left:10%;width:80%;","inputStyle":"width:50%;"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }